window.addEventListener('load', function () {
    //Récupérer les champs qui détectent le changement d'affichage
    let champsConditionnelsDeclenchementElements = document.querySelectorAll('.js-field-showing-if-trigger');

    champsConditionnelsDeclenchementElements.forEach(function (champConditionnelDeclenchementElement) {
        //Detecter les champs sur ces champs
        champConditionnelDeclenchementElement.addEventListener('change', function (event) {
            //Récupérer les champs qui sont affichés conditionnellement (qui dépendent du champ dont la valeur a changé)
            let champsConditionnelsElements = document.querySelectorAll(`.js-field-showing-if[data-other-field-name="${event.currentTarget.name}"]`);

            if (champsConditionnelsElements != null && champsConditionnelsElements.length > 0) {
                champsConditionnelsElements.forEach(function (champConditionnelElement) {
                    //Maquer à nouveau le champ
                    champConditionnelElement.classList.remove('d-block');
                    champConditionnelElement.classList.add('d-none');

                    champConditionnelElement.querySelector('input').disabled = true;
                    champConditionnelElement.querySelector('input').required = false;

                    //Vérifier si la valeur du champ déclencheur correspond à la valeur du champ conditionnel
                    let otherFieldValues = champConditionnelElement.getAttribute('data-other-field-value');
                    let otherFieldValuesArray = otherFieldValues.split('||');
                    if(otherFieldValuesArray.includes(event.currentTarget.value)) {
                        champConditionnelElement.classList.remove('d-none');
                        champConditionnelElement.classList.add('d-block');

                        champConditionnelElement.querySelector('input').disabled = false;

                        if(champConditionnelElement.getAttribute('data-current-field-required') === 'true') {
                            champConditionnelElement.querySelector('input').required = true;
                        }
                    }
                });
            }
        });
    });
});